import { render } from "./SidePanel.vue?vue&type=template&id=3523c6f0"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=3523c6f0&lang=css"
script.render = render

export default script